import { useEffect } from "react";

const CSS = `
.inv-drill-row-tip{position:relative;display:block;width:100%;}
.inv-drill-row-tip-hit{
  display:block;width:100%;border:none;background:transparent;padding:0;margin:0;
  font:inherit;text-align:inherit;cursor:pointer;
}
.inv-drill-row-tip-bubble{
  position:absolute;left:50%;bottom:calc(100% + 10px);transform:translateX(-50%);
  min-width:200px;max-width:300px;
  background:#fff;color:#2e3a35;
  border:1px solid rgba(30,40,34,.1);
  border-radius:10px;box-shadow:0 8px 24px rgba(16,24,20,.14);
  padding:10px 12px;z-index:5000;
  opacity:0;pointer-events:none;transition:opacity .15s ease;
  text-align:left;
}
.inv-drill-row-tip-comment{
  display:block;font-size:11px;line-height:1.45;font-weight:500;
  white-space:pre-line;color:#2e3a35;
}
.inv-drill-row-tip-cta{
  display:block;margin-top:8px;padding-top:8px;
  border-top:1px solid rgba(30,40,34,.08);
  font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;
  color:#b59a5b;
}
.inv-drill-row-tip:hover .inv-drill-row-tip-bubble,
.inv-drill-row-tip:focus-within .inv-drill-row-tip-bubble{opacity:1;}
.inv-drill-row-tip.inv-tip-down .inv-drill-row-tip-bubble{
  top:calc(100% + 10px);bottom:auto;
}
@media(max-width:820px){
  .inv-drill-row-tip-bubble{display:none;}
  .inv-drill-row-tip.inv-tip-open .inv-drill-row-tip-bubble{display:block;opacity:1;}
}
`;

function useDrillRowTipStyles() {
  useEffect(() => {
    if (document.getElementById("inv-drill-row-tip-css")) return;
    const s = document.createElement("style");
    s.id = "inv-drill-row-tip-css";
    s.textContent = CSS;
    document.head.appendChild(s);
  }, []);
}

/** Texte title natif (fallback table / accessibilité) */
export function drillRowTitle(comment, cta = "Open to drill down") {
  const c = String(comment || "").trim();
  return c ? `${c}\n\n${cta}` : cta;
}

/**
 * Ligne cliquable avec bulle : investor_comment + « Open to drill down » en bas.
 * @param {string} [comment] — Capital_flow.investor_comment
 */
export default function DrillRowTip({
  comment,
  children,
  className = "",
  style,
  onClick,
  onKeyDown,
  asButton = true,
  tipDown = false,
  disabled = false,
}) {
  useDrillRowTipStyles();
  const text = String(comment || "").trim();
  const cta = "Open to drill down";

  const bubble = (
    <span className="inv-drill-row-tip-bubble" role="tooltip">
      {text ? <span className="inv-drill-row-tip-comment">{text}</span> : null}
      <span className="inv-drill-row-tip-cta">{cta}</span>
    </span>
  );

  const wrapClass = `inv-drill-row-tip${tipDown ? " inv-tip-down" : ""}${className ? ` ${className}` : ""}`;

  if (!asButton) {
    return (
      <span
        className={wrapClass}
        style={style}
        title={drillRowTitle(comment)}
        onClick={(e) => {
          if (typeof window !== "undefined" && window.matchMedia("(max-width: 820px)").matches) {
            e.currentTarget.classList.toggle("inv-tip-open");
          }
        }}
      >
        {children}
        {bubble}
      </span>
    );
  }

  return (
    <span className={wrapClass} style={style}>
      <button
        type="button"
        className="inv-drill-row-tip-hit"
        disabled={disabled}
        title={drillRowTitle(comment)}
        onClick={(e) => {
          if (typeof window !== "undefined" && window.matchMedia("(max-width: 820px)").matches) {
            e.stopPropagation();
            e.currentTarget.closest(".inv-drill-row-tip")?.classList.toggle("inv-tip-open");
          }
          onClick?.(e);
        }}
        onKeyDown={onKeyDown}
      >
        {children}
      </button>
      {bubble}
    </span>
  );
}
